module.exports = __webpack_public_path__ + "static/img/12.b73a119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/12.png
// module id = s8g0
// module chunks = 1